import styled from 'styled-components';

const theme = {
  intuit: {
    color: '#0077c5',
    hoverColor: '#0077c5'
  },
  quickbooks: {
    color: '#53b700', // green03
    hoverColor: '#2CA01C' // green02
  },
  mint: {
    color: 'rgb(0,193,191)',
    hoverColor: 'rgb(0,193,191)'
  },
  proconnect: {
    color: 'rgb(0,119,197)',
    hoverColor: 'rgb(0,119,197)'
  },
  turbotax: {
    color: 'rgb(5,164,181)',
    hoverColor: 'rgb(5,164,181)'
  }
};

// ${getRadioBoxStyles('choiceText.fontSize')};
// DD will be changing to 1.4rem
// font color now consistent with label #6b6c72
export const Legend = styled.legend`
  color: #6b6c72;
  font-size: 14px;
  padding-left: 0;
  margin-bottom: 20px;
`;

export const Label = styled.span`
  color: #393a3d;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  padding-left: 8px;
  padding-right: 8px;
  margin-left: 20px;
  display: block;

  ${props =>
    props.disabled &&
    `
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
    opacity: 0.4;
  `};
`;

export const WrapperLabel = styled.label`
  display: inline-block;
  position: relative;
  margin-right: 8px;
  cursor: pointer;
  margin-bottom: 20px;

  ${props =>
    props.theme &&
    `
    &:hover span:first-of-type {
      border-color: ${theme[props.theme].hoverColor};
    };
  `};

  ${props =>
    props.disabled &&
    `
    pointer-events:none;
    cursor: not-allowed;
  `};

  ${props =>
    props.checked &&
    `
    &:after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      content: '';
      visibility: hidden;
    }
  `};
`;

// Radio Group Styles
export const Fieldset = styled.fieldset`
  display: block;
  border: 0;
  margin: 0;
  padding: 0;

  ${props =>
    props.vertical &&
    `
    display: flex;
    flex-direction: column;
    width:100%;
  `};
`;
